import React from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import { BoxWrapper } from 'components/Base';
import TableComponents from 'components/Table';
import Forms from 'components/Forms';

const useStyles = makeStyles((theme: Theme) => ({
  rows: {
    padding: '0.2rem',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(0)
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2)
  },
  table: {
    width: 'calc(100% + 1px)' // fix chrome bug,
  },
  tableBody: {
    '& tr:nth-child(odd)': {
      backgroundColor: '#f7f7f7'
    }
  },
  wrapper: {
    margin: '12px 0',
    marginRight: '10px'
  },
  loaderWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
}));

interface ChargesProps {
  fields?: any;
  meta?: any;
  allowPercentageValue: boolean;
  formName: string;
  totalFundValue: string;
  isModelPortfolioInPolicy: boolean;
}

const Charges = ({
  fields,
  totalFundValue,
  allowPercentageValue,
  formName,
  isModelPortfolioInPolicy
}: ChargesProps) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <BoxWrapper title=" Cost & charges">
        <Table className={classes.table}>
          <TableComponents.TableHead cells={['Charges', '% p.a.', '£ p.a.']} />
          <TableComponents.TableBody>
            {fields.map((charge: any, index: number) => {
              const chargeValues = fields.get(index);
              const isModelPortfolioCharge = chargeValues.kind === 8;

              if (isModelPortfolioCharge && !isModelPortfolioInPolicy) {
                return null;
              }
              return (
                <Forms.ManagePolicies.Charge
                  key={index}
                  charge={charge}
                  chargeValues={chargeValues}
                  allowPercentage={allowPercentageValue}
                  formName={formName}
                  totalFundValue={totalFundValue}
                />
              );
            })}
          </TableComponents.TableBody>
        </Table>
      </BoxWrapper>
    </div>
  );
};

export default Charges;
